import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import AppLayout from '../components/Layout/AppLayout';
import PerformanceDashboard from '../components/TalentProfile/PerformanceDashboard';
import RedesignedProfileCard from '../components/TalentProfile/RedesignedProfileCard';
import CalibrationInsightsCard from '../components/TalentProfile/CalibrationInsightsCard';

import { TalentCardData } from '../types';
import TalRevAPI from '../services/api';

const TalentDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [talentCard, setTalentCard] = useState<TalentCardData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);


  useEffect(() => {
    const fetchTalentCard = async () => {
      try {
        if (id) {
          const data = await TalRevAPI.getTalentCard(id);
          setTalentCard(data);
        }
      } catch (err) {
        console.error('Error fetching talent card:', err);
        setError('Failed to load talent card data');
      } finally {
        setLoading(false);
      }
    };

    fetchTalentCard();
  }, [id]);





  if (loading) {
    return (
      <AppLayout>
        <div className="flex justify-center items-center min-h-screen">
          <div className="text-center">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600 mx-auto"></div>
            <p className="mt-4 text-[var(--text-tertiary)]">Loading talent details...</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  if (error || !talentCard) {
    return (
      <AppLayout>
        <div className="flex justify-center items-center min-h-screen">
          <div className="text-center">
            <p className="text-[var(--error-color)] text-[var(--font-size-lg)]">{error || 'Talent card not found'}</p>
          </div>
        </div>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <div className="max-w-7xl mx-auto px-4 py-6 space-y-6">
        {/* Profile Card */}
        {talentCard.extractedDocumentData && (
          <RedesignedProfileCard
            extractedData={talentCard.extractedDocumentData}
            scoringResults={talentCard.scoringResults}
            talentId={id}
          />
        )}

        {/* Performance Scores */}
        <PerformanceDashboard talentCard={talentCard} />

        {/* Calibration Insights */}
        {talentCard.calibrationInsights && (
          <CalibrationInsightsCard 
            calibrationInsights={talentCard.calibrationInsights}
            className=""
          />
        )}

        {/* Content - All specified sections removed */}
      </div>
    </AppLayout>
  );
};

export default TalentDetails;